import React from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';


export const Presidents = (props) => {
  return (
    <div id="presidents" >
      <div className="container">
        <div className="section-title text-center">
          <h2>Board of Directors</h2>
        </div>
        <div className="row" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          {props.data && props.data.length > 0 ? (
            props.data.map((d, i) => (
              <div className="col-md-3 col-sm-6" key={`${d.name}-${i}`}>
                <Popup trigger={<button type="button" style={{ border: 'none', outline: 'none', boxShadow: 'none', background: 'transparent', padding: 0 }}><img src={d.img} alt={d.name} className="team-img" style={{ border: 'none', boxShadow: 'none' }} /></button>} modal>
                  <div className="caption">
                    <h3>{d.name}</h3>
                    <p>{d.job}</p>
                    <p>{d.caption}</p>
                  </div>
                </Popup>
                <div className="caption">
                  <h4>{d.name}</h4>
                  <p>{d.job}</p>
                </div>
              </div>
            ))
          ) : (
            <p>Loading presidents' details...</p>
          )}
        </div>
      </div>
    </div>
  );
};